import React, {useMemo} from 'react';
import {Checkbox} from "antd";
import {IPropsElement} from "../../../pages/ChecklistPage/PopupEdit/constants";
import {callEventChecklist, getChecklist, useChecklist} from "../ChecklistContext";

const CheckboxElement: React.FC<IPropsElement> = (props) => {
    const {options = '', numberOfColumns = 1, optionDefault} = props.properties;
    const {index} = props;
    const [value = optionDefault] = useChecklist(state => state.result[index]);
    const {onResultChange} = callEventChecklist();
    const {disabled} = getChecklist()();

    const opts = useMemo(() => options.length > 0 ? options.split('\n').reduce((list: any[], item, index) => {
        if (item.trim().length > 0)
            list = [...list, {label: item, value: `${index}`}]
        return list;
    }, []) : [], [options]);

    const style = {
        display: 'grid',
        alignItems: 'center',
        gridTemplateColumns: `repeat(${Math.max(numberOfColumns)}, 1fr)`
    };

    return <Checkbox.Group
        disabled={disabled}
        style={style}
        options={opts}
        value={value}
        onChange={checked => onResultChange({[index]: checked})}
    />;
};

export default CheckboxElement;
